import Checkbox from '@material-ui/core/Checkbox';
import TextField from '@material-ui/core/TextField';
import noop from 'lodash/noop';
import PropTypes from 'prop-types';
import React from 'react';
import { Field } from 'react-final-form';

/* eslint-disable react/prop-types */
/* eslint-disable react/jsx-props-no-spreading */

const FormField = ({
  name,
  id,
  className,
  label,
  validate,
  autoFocus,
  type,
  maxLength,
  rowsMax,
  multiline,
  required,
  disabled,
  submitOnEnter,
}) => {

  let render = () => { };
  switch (type) {
    case 'checkbox':
      render = ({ input }) => (
        <Checkbox
          id={id}
          className={className}
          autoFocus={autoFocus}
          required={required}
          color="primary"
          disabled={disabled}
          {...input}
        />
      );
      break;
    default:
      render = ({ input, meta }) => {
        const showError = !!meta.error && !!meta.touched;
        return (
          <TextField
            id={id}
            className={className}
            label={label}
            autoFocus={autoFocus}
            fullWidth
            rowsMax={rowsMax}
            multiline={multiline}
            required={required}
            error={showError}
            disabled={disabled}
            InputProps={{
              inputProps: {
                maxLength,
                autoComplete: 'off',
                'aria-required': required,
                onKeyPress: e => {
                  if (e.key === 'Enter' && !submitOnEnter && !multiline) e.preventDefault();
                },
              },
            }}
            {...input}
          />
        );
      };
      break;
  }

  return <Field
    name={name}
    className={className}
    id={id}
    type={type}
    validate={validate}
    render={render}
  />;
};

FormField.propTypes = {
  name: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  className: PropTypes.string,
  validate: PropTypes.func,
  autoFocus: PropTypes.bool,
  type: PropTypes.string,
  maxLength: PropTypes.number,
  required: PropTypes.bool,
  rowsMax: PropTypes.number,
  multiline: PropTypes.bool,
  submitOnEnter: PropTypes.bool,
  disabled: PropTypes.bool,
};

FormField.defaultProps = {
  validate: noop,
  autoFocus: false,
  type: 'text',
  maxLength: 30,
  required: false,
  rowsMax: 1,
  multiline: false,
  submitOnEnter: false,
  disabled: false,
  className: undefined,
};

export default FormField;
